import { Dto } from "../../../parts/crud/dto";
import * as Yup from 'yup';
export class serverGroupDto extends Dto{
  constructor() {
  super();
      this.data.initialValues = {
        group_name: '',
        group_description: '',
        servers: [],
   
      }
      this.data.validationSchema = Yup.object({
        group_name: Yup.string().required("GENERIC.ERRORS.REQUIRED"),
        group_description: Yup.string().required("GENERIC.ERRORS.REQUIRED"),
        servers: Yup.array().test('len', "SYSTEM_SETTINGS.SERVER_GROUP.SELECT_AT_LEAST_ONE_SERVER", (val:any) => (val && val.length > 0)),
      });
    }
}